import styled from 'styled-components';

const HomePageLayout = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  z-index: 2;
  height: 100vh;
`;

const FeaturedRoutesContainer = styled.div`
  display: grid;
  grid-gap: 3rem;

  // Small devices (landscape phones, 576px and up)
  @media (min-width: 576px) {
    grid-template-columns: 1fr;
  }

  // Medium devices (tablets, 768px and up)
  @media (min-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }

  // Large devices (desktops, 992px and up)
  @media (min-width: 992px) {
    grid-template-columns: repeat(2, 1fr);
  }

  // Extra large devices (large desktops, 1200px and up)
  @media (min-width: 1200px) {
    grid-template-columns: repeat(auto-fill, 400px);
  }
  max-width: 100rem;
  margin: 0 auto;
`;

const FeaturedRoutesTitle = styled.h1`
  margin-left: 2rem;

  font-family: Montserrat;
  font-style: normal;
  font-weight: bold;
  font-size: 32px;
  line-height: 116%;
  /* or 37px */

  color: #7f7f7f;
`;

const ProgressContainer = styled.div`
  margin-top: 10rem;
  margin: 0 auto;
`;

export { HomePageLayout, FeaturedRoutesContainer, FeaturedRoutesTitle, ProgressContainer };
